import {
    windowWidth,
    mobileMatch,
    smoothScrollToTarget
} from '../common';

let fileList = [];

export default class Tech {
    constructor() {
        $('#inputPhone').mask("+38 (099) 999-99-99", {autoclear: false, completed: Tech._validateFields});
        $('#inputBirth').mask("99/99/9999", {autoclear: false, completed: Tech._validateFields});

        this._sendFormToServer = this._sendFormToServer.bind(this);

        $(document)
            .on('click', '.js-tech-card-unit', this._switchCard)
            .on('click', '.js-tech-scroll-to', smoothScrollToTarget)
            .on('click', '.tech_page--bottom-form-submit', this._sendFormToServer)
            .on('input', ".tech_page--bottom-form input", Tech._validateFields)
            .on('click', '.tech_page--rs-popup i', this._removeRenderedResopnse);

        document.addEventListener('click', Tech._removePhoto, false);
        if (document.getElementById('work-photo'))
            document.getElementById('work-photo').addEventListener('change', this.handleFileSelect, false);
    }

    _switchCard() {
        if (!mobileMatch.matches) {
            let $ct = $('.tech_page--middle'),
                $card = $(this).closest('.js-tech-card'),
                id = $card.attr('data-for');
            if (!$card.hasClass('active')) {
                $ct.find('.js-tech-card').removeClass('active');
                $ct.find('.tech_page--middle-cards-text').removeClass('active');
            }
            $ct.find('.tech_page--middle-cards-text[data-for=' + id + ']').addClass('active');
            $card.addClass('active');
        }
    };

    handleFileSelect(evt) {
        let files = evt.target.files;
        let parent = evt.target.parentNode;

        if (evt.target.getAttribute('id') === "profile-photo") {
            parent.querySelectorAll(".tech_page--form-image").forEach(function (i) {
                i.remove();
            });
            if (files.length > 0)
                parent.classList.add('done');
        }


        for (let i = 0, f; f = files[i]; i++) {

            if (!f.type.match('image.*')) {
                continue;
            }

            let reader = new FileReader();

            reader.onload = (function (file) {
                return function (e) {
                    let imgContainer = document.createElement('div');
                    imgContainer.setAttribute('data-file', file.name);
                    imgContainer.setAttribute('data-size', file.size);
                    imgContainer.className = "tech_page--bottom-form-image";
                    imgContainer.innerHTML = ['<img src="', e.target.result, '" title="', escape(file.name), '"/><div class="tech_page--bottom-form-image-mask"></div>'].join('');
                    parent.insertBefore(imgContainer, parent.querySelector("#work-photo"));
                    // Tech._collectAllFiles();
                };
            })(f);

            fileList.push(f);
            reader.readAsDataURL(f);
        }
        Tech._validateFields();
        if (files)
            parent.classList.add("exist");
    }

    static _removePhoto(e) {
        if (e.target.classList.contains('tech_page--bottom-form-image-mask')) {
            let container = e.target.closest(".tech_page--bottom-form-block");

            let fileName = e.target.parentNode.getAttribute('data-file'),
                fileSize = e.target.parentNode.getAttribute('data-size');

            e.target.parentNode.remove();

            fileList.forEach((e,i)=>{
                if (fileName === e.name && parseInt(fileSize) === e.size) fileList.splice(i, 1);
            });

            if (container.querySelector("#profile-photo")) {
                container.classList.remove('done');
            }
            if (container.querySelectorAll(".tech_page--bottom-form-image").length === 0) {
                container.classList.remove('exist');
                container.querySelector("#work-photo").value = '';
            }

            // Tech._collectAllFiles();
        }
    }

    static _collectAllFiles() {
        let inputWork = document.querySelector('#work-photo-list');

        inputWork.value = Tech._storeValueInInput(inputWork);
    }

    static _storeValueInInput(input) {
        let arr = [];
        input.parentNode.querySelectorAll(".tech_page--bottom-form-image").forEach(function (i) {
            arr.push(i.getAttribute('data-file') + i.getAttribute('data-size'));
        });
        return arr.join(', ');
    }

    static _getFormValue(selector) {
        let form = document.querySelector('.tech_page--bottom-form');
        return form.querySelector(selector).value;
    }

    _sendFormToServer() {
        let obj = {};
        let form = document.querySelector('.tech_page--bottom-form');
        let data = new FormData();
        data.append('method', 'addTechnolog');
        data.append('name', Tech._getFormValue('#inputName'));
        data.append('city', Tech._getFormValue('#inputCity'));
        data.append('phone', Tech._getFormValue('#inputPhone'));
        data.append('saloon', Tech._getFormValue('#inputSaloon'));
        data.append('email', Tech._getFormValue('#inputMail'));
        data.append('estelExp', Tech._getFormValue('#inputBrandExp'));
        data.append('birth', Tech._getFormValue('#inputBirth'));
        data.append('proExp', Tech._getFormValue('#inputExp'));
        data.append('comment', Tech._getFormValue('#inputComment'));
        // obj.method = 'addTechnolog';
        // obj.name = Tech._getFormValue('#inputName');
        // obj.city = Tech._getFormValue('#inputCity');
        // obj.phone = Tech._getFormValue('#inputPhone');
        // obj.saloon = Tech._getFormValue('#inputSaloon');
        // obj.email = Tech._getFormValue('#inputMail');
        // obj.estelExp = Tech._getFormValue('#inputBrandExp');
        // obj.birth = Tech._getFormValue('#inputBirth');
        // obj.proExp = Tech._getFormValue('#inputExp');
        // obj.comment = Tech._getFormValue('#inputComment');
        // obj.photos = fileList;
        fileList.forEach((f,i)=>{
            data.append('file[]', f);
        });

        if(Tech._validateFields()) {
            $.ajax({
                url: '/tehnolog/',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                type: "POST",
                data: data,
                contentType: false,
                processData: false
            }).done((res) => {
                Tech._renderResponse('success', 'Заявка відправлена');
                Tech._clearForm();
            }).fail((res)=>{
                Tech._renderResponse('error', 'Помилка, не вдалось відправити заявку. Спробуйте ще раз');
            });
        }
    }

    static _clearForm() {
        let form = document.querySelector('#register-form'),
            inputList = form.querySelectorAll('input');
        inputList.forEach((i)=>{
            i.value = '';
        });
        let photos = document.querySelector(".tech_page--bottom-form-block.photos");
        photos.classList.remove('exist');
        photos.querySelectorAll('.tech_page--bottom-form-image').forEach((i)=>{
            i.remove();
        });
        document.querySelector('.tech_page--bottom-form-submit').classList.remove('active');
    }

    static _renderResponse(type, text) {
        let ct = document.createElement('div');

        ct.className = 'tech_page--rs';
        ct.innerHTML = '<div class="tech_page--rs-popup '+type+'"><i></i>'+text+'</div>';

        document.querySelector('.tech_page').appendChild(ct);
    }

    _removeRenderedResopnse() {
        let rs = document.querySelector('.tech_page--rs');
        rs.classList.add('remove');
        setTimeout(()=>{
            rs.remove();
        },225);
    }


    static _validateFields() {
        let ok = true;
        let selector = document.querySelector('.tech_page--bottom-form');
        let btn = selector.querySelector(".tech_page--bottom-form-submit");
        selector.querySelectorAll('input').forEach((e)=>{
            if (e.value && e.value.length !== 0) {
                e.classList.remove('error');
                if (e.getAttribute('id') === 'work-photo')
                    e.parentNode.querySelector('.checked').classList.remove('error');
            } else {
                e.classList.add('error');
                if (e.getAttribute('id') === 'work-photo')
                    e.parentNode.querySelector('.checked').classList.add('error');
                ok = false;
            }
        });

        if (ok)
            btn.classList.add('active');
        else
            btn.classList.remove('active');

        return ok;
    }

}



